export enum AgeGroupNumber{
  INFANT = '0_2', //0-2
  PRESCHOOL = '3_5', //2-5
  CHILD = '6_13', //5-13
  ADOLESCENT = '14_17', //13-19
  ADULT = '18_64', //19-65
  ELDERLY = '65_150' //>65
}
